import React, { useState } from 'react';
import { SearchIcon } from '../../../assets';

function SearchForm({
  rootClassName,
  searchBarIcon,
  searchBarClassName,
  handleSubmit,
  searchValue,
  setSearchVlaue,
  placeholder,
}) {
  return (
    <form className={rootClassName} onSubmit={handleSubmit}>
      <SearchIcon className={searchBarIcon} onClick={handleSubmit} />
      <input
        className={searchBarClassName}
        id="keyword-search"
        type="search"
        placeholder={placeholder}
        onChange={e => setSearchVlaue(e.target.value)}
        value={searchValue}
      />
    </form>
  );
}

export default SearchForm;
